import styled from 'styled-components'
import { ChevronRightIcon } from '@diversioteam/diversio-ds'

import NavbarOptionCurvedLine from 'assets/images/navbar-option-curved-line.svg'

import {
    ListItem as SharedListItem,
    OptionsItem as SharedOptionsItem,
    Label as SharedLabel,
} from './../List/list.styles'

export const ListItemWrapper = styled(SharedListItem)``

export const OptionsItem = styled(SharedOptionsItem)``

export const CustomSlotContent = styled.div`
    padding: 0px 0 20px 30px;
    width: 100%;
`

export const Expand = styled(ChevronRightIcon)`
    margin-left: auto;
    transform: rotateZ(90deg);
    transform-origin: center;
    transition: transform 0.1s ease-in;
`

export const Group = styled.ul`
    width: 100%;
    list-style-type: none;
    padding-left: 0px;
`

export const GroupItem = styled.li`
    margin: 10px 0px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        mask-image: url('${NavbarOptionCurvedLine}');
        mask-size: contain;
        mask-position: center;
        mask-repeat: no-repeat;
        height: 60px;
        width: 22px;
        background-color: ${({ theme }) => theme.colors.primary70};
        left: 20px;
        top: -38px;
    }
`
export const BasicOptionsItem = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
`

export const ParentBasicOptionsItem = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
`

export const NestedOptionsItem = styled(OptionsItem)`
    width: calc(100% - 55px);
    margin-left: 40px;
    padding: 0px 2px;

    :is(a) {
        margin-left: 40px;
        padding: 0px 2px;
    }

    ${Expand} {
        margin-left: auto;
        transform: rotateZ(0deg);
        display: none;
    }

    &.active {
        ${Expand} {
            display: block;
        }
    }
`

export const Label = styled(SharedLabel)``
